export default "__VITE_ASSET__C8DdV1Rs__"